/*eslint-disable*/
import api from '../'

class hardSoftConsonantsGameItems {
    // POST: couples
    static getItemsByRequest (params) {
        return api.axios.get('/hardSoftConsonants/items', { params }).then(response => response.data.items);
    }
}

export default hardSoftConsonantsGameItems;
